
import React from 'react';
import AppRoutes from './Routes';

function App() {
  // Simple frontend-only application - no backend dependencies
  
  // Render the application routes
  return (
    <AppRoutes />
  );
}

export default App;